import Carousel from "react-multi-carousel";
import GuestSpeakerCard from "./GuestSpeakerCard";
import '../../../styles/Home/guestSpeakers.scss'

const GuestSpeakers = () => {
  return (
    <section id="guests" className="guest">
      <h1 className="guest__heading">
        Guest Speakers
      </h1>

      <div className="guest__cards">
        <Carousel
          additionalTransfrom={0}
          arrows
          autoPlay
          autoPlaySpeed={3000}
          centerMode={false}
          className=""
          containerClass="container-with-dots"
          dotListClass=""
          draggable
          focusOnSelect={false}
          infinite
          itemClass=""
          keyBoardControl
          minimumTouchDrag={80}
          pauseOnHover
          renderArrowsWhenDisabled={false}
          renderButtonGroupOutside={false}
          renderDotsOutside={false}
          responsive={{
            desktop: {
              breakpoint: {
                max: 3000,
                min: 1360
              },
              items: 3,
              partialVisibilityGutter: 40
            },
            mobile: {
              breakpoint: {
                max: 750,
                min: 0
              },
              items: 1,
              partialVisibilityGutter: 30
            },
            tablet: {
              breakpoint: {
                max: 1360,
                min: 750
              },
              items: 2,
              partialVisibilityGutter: 30
            }
          }}
          rewind={false}
          rewindWithAnimation={false}
          rtl={false}
          shouldResetAutoplay
          showDots={false}
          sliderClass=""
          slidesToSlide={1}
          swipeable
        >

          <GuestSpeakerCard
            pfp='https://media.licdn.com/dms/image/D4D03AQGIuq_2QiHGvw/profile-displayphoto-shrink_200_200/0/1679581907818?e=1689811200&v=beta&t=xWD6Ez33xyPOs6ifC_N_riLzmQEpYVN9FMnNRy0I-w8'
            name='Ahmad Khan'
            role='Software Engineer @Jaldi | Community Manager @GoogleDevs'
            linkedin='https://www.linkedin.com/in/rmahmadkhan/'
            github={null}
            twitter={null}
          />

          <GuestSpeakerCard
            pfp='https://media.licdn.com/dms/image/D4D03AQENWVP3f937eg/profile-displayphoto-shrink_200_200/0/1670220484124?e=1689811200&v=beta&t=a3HYwlH4_BqAqWUxnXqOLvN7RX2ZWIHJ0ImcC8HBbcU'
            name='Farhan Ashraf'
            role='DevSecOps Engineer at Systems Limited | GCE GDG'
            linkedin='https://www.linkedin.com/in/farhanashrafdev/'
            github={null}
            twitter={null}
          />

          <GuestSpeakerCard
            pfp='https://media.licdn.com/dms/image/D4D03AQFfvKsTrOIStA/profile-displayphoto-shrink_200_200/0/1673894542254?e=1689811200&v=beta&t=QBraL53158iRl3_HszGmRLBGx2hRnRCDO6sEqn01Fq4'
            name='Adil Shehzad'
            role='DevOps Engineer | Microsoft Certified Trainer'
            linkedin='https://www.linkedin.com/in/adilshehzad7/'
            github={null}
            twitter={null}
          />

          <GuestSpeakerCard
            pfp='https://media.licdn.com/dms/image/C4D03AQHKk8ydAmmeNw/profile-displayphoto-shrink_200_200/0/1661416989249?e=1689811200&v=beta&t=ejvN3neUqMqZuOvjdomMUn4NmvEO0wpEcvCcZsGAJ2s'
            name='Rao Waqas Akram'
            role='Sr. Software Engineer | Campus Gold Medalist'
            linkedin='https://www.linkedin.com/in/raowaqasakram/'
            github={null}
            twitter={null}
          />

          <GuestSpeakerCard
            pfp='https://media.licdn.com/dms/image/C4D03AQGuDDKAmhF9zA/profile-displayphoto-shrink_200_200/0/1607704780759?e=1689811200&v=beta&t=xNqjojbCqfK8O6I62nAGQ-tJXiYOrk8r80wOGFlfWW0'
            name='Kashif Sohail'
            role='Data Platform Engineer at Motive | x Careem | x Easypaisa'
            linkedin='https://www.linkedin.com/in/kshfse/'
            github={null}
            twitter={null}
          />

        </Carousel>
      </div>
    </section>
  )
}

export default GuestSpeakers;